module.exports = __webpack_public_path__ + "static/media/youtube.c49215f6.svg";